import axios from "axios";
import url from "../../helpers/url";

const HandleBoilerplate = async ({ user, userInfo, empty_cart }) => {
  const response = await axios
    .put(
      `${url}/users/${userInfo.id}`,
      {
        cart: empty_cart(),
      },
      {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      }
    )
    .catch((error) => console.log(error));
  return response;
};

export { HandleBoilerplate as default };
